
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react"
import Home from "./home.jsx";
import LandingPage from './landingPage.jsx';
import Chapter2 from './ChapterTwo/chapter2.jsx';
import Chapter3 from './ChapterThree/chapter3.jsx';
// import Chapter3 from './SectionThree/chapter3.jsx';
import Chapter4 from './ChapterFour/chapter4.jsx';
import Chapter5 from './ChapterFive.jsx/chapter5.jsx';
import Chapter6 from './chapter6.jsx';
import Chapter7 from './ChapterSeven/chapter7.jsx';
import Chapter8 from './chapter8.jsx';
import ChapterOne from './chapterOne/chapter1.jsx';
import SectionOne from './chapterOne/SectionOne.jsx';
import SectionTwo from './chapterOne/SectionTwo.jsx';
import SectionTwo5 from './ChapterFive.jsx/SectionTwo.jsx';
import SectionThree5 from './ChapterFive.jsx/SectionThree.jsx';
import SectionThree from './chapterOne/SectionThree.jsx';
import SectionFour from './chapterOne/SectionFour.jsx';
import ChapterTwoOne from './ChapterTwo/SectionOne.jsx';
import ChapterTwoTwo from './ChapterTwo/SectionTwo.jsx';
import Steps from './ChapterFour/SectionOne.jsx';
import DataCollection from './ChapterFive.jsx/SectionOne.jsx';
import SearchComponent from './search.jsx';
import Chapter2Questions from './ChapterTwo/questions.jsx';
import Chapter3Questions from './ChapterThree/questions.jsx';
import Chapter1Questions from './chapterOne/questions.jsx';
import Chapter4Questions from './ChapterFour/questions.jsx';
import Chapter5Questions from './ChapterFive.jsx/questions.jsx';
import Chapter7Questions from './ChapterSeven/questions.jsx';
import Chapter7SectionTwo from './ChapterSeven/sectionTwo.jsx';
import ChapterOneVideo from './chapterOne/video.jsx';
import Chapter7SectionThree from './ChapterSeven/sectionThree.jsx';
import Feedback from './feedbackform.jsx'
import { useState, useEffect } from "react";
import StickyNavbar from './navbar.jsx';
import ChapterQuestionsPopup from "./QuizPopup.jsx"; // Ensure this component exists
import ChapterFIveVideo from './ChapterFive.jsx/video.jsx';
import ChapterTwoVideo from './ChapterTwo/video.jsx';
import ChapterTwoPrinciples from './ChapterTwo/chapter2principles.jsx';
import ChapterFourVideo from './ChapterFour/video.jsx';



const App = () => {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
const location = useLocation();
  // useEffect(() => {
  //   // Show popup automatically after 2 seconds
  //   const timer = setTimeout(() => {
  //     setIsFeedbackOpen(true);
  //   }, 2000);

  //   return () => clearTimeout(timer);
  // }, []);
  const [isQuestionPopupOpen, setIsQuestionPopupOpen] = useState(false);
  const [selectedChapter, setSelectedChapter] = useState(null);

  const openChapterQuestions = (chapter) => {
    setSelectedChapter(chapter);
    setIsQuestionPopupOpen(true);
  };
  const openFeedback = () => setIsFeedbackOpen(true);
  const closeFeedback = () => setIsFeedbackOpen(false);


  return (
   <>
    <Routes>
 
    {/* <Route path="/" element={<Home />} /> */}
    <Route path="/" element={<LandingPage />} />
    <Route path="/search" element={<SearchComponent />} />
    <Route path='/chapter1' element={<ChapterOne/>}/>
    <Route path='/chapter1/sectionOne' element={<SectionOne/>}/>
    <Route path='/chapter1/questions' element={<Chapter1Questions/>}/>
    <Route path='/chapter1/video' element={<ChapterOneVideo/>}/>

    <Route path='/chapter1/sectionTwo' element={<SectionTwo/>}/>
    <Route path='/chapter1/sectionThree' element={<SectionThree/>}/>
    <Route path='/chapter1/sectionThree' element={<SectionThree/>}/>
    <Route path='/chapter1/sectionFour' element={<SectionFour/>}/>
    
    <Route path='/chapter2' element={<Chapter2/>}/>
    <Route path='/chapter2/video' element={<ChapterTwoVideo/>}/>
    <Route path='/chapter2/principles' element={<ChapterTwoPrinciples/>}/>
    <Route path='/chapter2/sectionOne' element={<ChapterTwoOne/>}/>
    <Route path='/chapter2/sectionTwo' element={<ChapterTwoTwo/>}/>
    <Route path='/chapter2/questions' element={<Chapter2Questions/>}/>

    <Route path='/chapter3' element={<Chapter3/>}/>
    <Route path='/chapter3/questions' element={<Chapter3Questions/>}/>

    <Route path='/chapter4' element={<Chapter4/>}/>
    <Route path='/chapter4/video' element={<ChapterFourVideo/>}/>
    <Route path='/chapter4/stages' element={<Steps/>}/>
    <Route path='/chapter4/questions' element={<Chapter4Questions/>}/>

    <Route path='/chapter5/video' element={<ChapterFIveVideo/>}/>
    <Route path='/chapter5' element={<Chapter5/>}/>
    <Route path='/chapter5/data' element={<DataCollection/>}/>
    <Route path='/chapter5/sectionTwo' element={<SectionTwo5/>}/>
    <Route path='/chapter5/sectionThree' element={<SectionThree5/>}/>
    <Route path='/chapter5/questions' element={<Chapter5Questions/>}/>
    <Route path='/chapter6' element={<Chapter6/>}/>
    <Route path='/chapter7' element={<Chapter7/>}/>
    <Route path='/chapter7/sectionTwo' element={<Chapter7SectionTwo/>}/>
    <Route path='/chapter7/sectionThree' element={<Chapter7SectionThree/>}/>
    <Route path='/chapter7/questions' element={<Chapter7Questions/>}/>

    <Route path='/references' element={<Chapter8/>}/>
   
    <Route path='/feedback' element={<Feedback/>}/>
    </Routes>

{location.pathname !== "/" && <StickyNavbar onOpenFeedback={openFeedback}  openChapterQuestions={openChapterQuestions}/>}
{/* {location.pathname !== "/" && <StickyNavbar openChapterQuestions={openChapterQuestions} />} */}



    {isFeedbackOpen && <Feedback isOpen={isFeedbackOpen} onClose={closeFeedback} />}
    {isQuestionPopupOpen && (
        <ChapterQuestionsPopup 
          chapter={selectedChapter} 
          onClose={() => setIsQuestionPopupOpen(false)} 
        />
      )}
    </>
  );
}


export default App;
